export default {
  AudioButton: {
    play: 'Play',
  },
  ezinterview_video_help: {
    section1: [
      '1. Browser detection failed.',
      'chrome 60 or above is required for the video interview. Please download the browser according to the relevant version:',
      'window version download',
      'Download for mac',
      'linux version download',
      'Download ios version',
      'android version download',
      'No other browsers are currently supported.',
    ],
    section2: [
      '2. Camera detection failed.',
      '(1) Make sure that the device has a camera or an external camera device and that drivers are installed.',
      '(2) Please turn off computer anti-virus software, proxy VPN, etc. to ensure that the network speed is above 100kb/s.',
      '(3) Allow the browser to enable camera permissions (click Allow).',
      '(4) Check whether the camera and microphone Settings are disabled on the right side of the browser address bar.',
      '(5) In the security Settings, please set the webcam, microphone and sound permissions to allow.',
    ],
    section3: [
      '3. Microphone detection failed.',
      '(1) Please ensure that the device has a microphone or an external microphone device and that the driver is installed. The device is not turned to silent mode.',
      '(2) Please turn off computer anti-virus software, proxy VPN, etc. to ensure that the network speed is above 100kb/s.',
      '(3) Allow the browser to enable microphone permissions (please click Allow).',
      '(4) Check whether the camera and microphone Settings are disabled on the right side of the browser address bar.',
      '(5) In the security Settings, please set the webcam, microphone and sound permissions to allow.',
    ],
    section4: [
      '4. Sound detection failed.',
      '(1) Please ensure that the computer is equipped with speakers or headphones, and the relevant drivers are installed, and the device is not turned to silent mode.',
      '(2) Please turn off computer anti-virus software, proxy VPN, etc. to ensure that the network speed is above 100kb/s.',
      '(3) Allow the browser to enable camera, microphone permissions (click Allow).',
      '(4) Check whether the camera and microphone Settings are disabled on the right side of the browser address bar.',
      '(5) In the security Settings, please set the webcam, microphone and sound permissions to allow.',
    ],
    tips: 'Go to the app store and search for the latest version of chrome browser to download',
  },
  grading_level: {
    title: 'Rating criteria',
  },
  history_score: {
    absent: 'The candidate withdrew and has no result',
    fraud: 'Candidate fraud, no result',
    exempt: 'The candidate is exempt; no score is calculated',
  },
  interviewer_navbar: {
    time: 'Beijing time',
  },
  language_select: {
    changeLanguage: 'Change system language',
  },
  loginout_btn: {
    logout: 'Log out',
    signOutCofirm: 'Sure to opt out of the interview scoring system?',
    signOutCancel: 'signout cancel',
  },
  navbar: {
    placeholder: 'name',
  },
  operate_and_time: {
    time: 'Beijing Time',
  },
  operate_mobile: {
    title: 'Device detection',
  },
  pre_detection: {
    title: 'Device Detection',
    browser: 'Browser',
    help: 'Help?',
    video: 'Camera',
    audio: 'Microphone',
    broadWidth: 'Video Bandwidth',
    delay: 'Latency',
    confirm: 'Confirm',
    helpTitle: 'Easy Interview Help',
    close: 'close',
    btnName1: ['Detect microphone', 'Stop recording...'],
    btnName2: ['Play sound', 'Stop playing'],
    audioDevice: 'Microphone device',
    videoDevice: 'camera device',
    audioMsg: 'Please stop playing',
    audioConfirmMsg:
      'During microphone detection, the system will record a segment of your voice, and you can click the Play sound button to determine if the microphone is valid.',
    recordMsg1: 'Please click to detect microphone first',
    recordMsg2: 'Please stop recording first',
    errorTips: 'Please try to open this page through a browser to access the camera device',
    back: 'Back',
    precheck: 'Pre-interview check',
    recheck: 'Run Again',
    speaker: 'Speaker',
    network: 'Network',
    playSpeaker: 'Play Test Tone',
    heardSpeaker: 'I Heard It',
    notHeardSpeaker: "I Didn't Hear It",
    readyItems: 'Passed items',
    version: 'Version',
    secureContext: 'Secure context',
    onlineStatus: 'Online status',
    yes: 'Yes',
    no: 'No',
    online: 'Online',
    offline: 'Offline',
    unknown: 'Unknown',
    idle: 'Pending',
    checking: 'Checking',
    passed: 'Passed',
    warning: 'Warning',
    failed: 'Failed',
    cameraPlaceholder: 'Select camera',
    microphonePlaceholder: 'Select microphone',
    cameraWaiting: 'Waiting for camera check',
    cameraStarting: 'Starting camera...',
    cameraReady: 'Camera preview is working',
    microphoneWaiting: 'Waiting for microphone check',
    microphoneStarting: 'Starting microphone...',
    microphoneReady: 'Microphone input is working',
    microphoneLevel: 'Microphone level',
    microphoneTip: 'Speak into the microphone. A moving level bar means input is working.',
    speakerWaiting: 'Click play to hear the speaker test tone',
    speakerPlaying: 'Playing test tone...',
    speakerConfirm: 'If you heard the test tone, click “I Heard It”',
    speakerReady: 'Speaker playback is working',
    speakerNotHeard: 'Check the system volume, tab mute status, and audio output device.',
    speakerFailed: 'Failed to play the test tone. Check browser audio permission and system volume.',
    networkWaiting: 'Waiting for network check',
    networkChecking: 'Checking network...',
    networkReady: 'Network connection is normal',
    networkSlow: 'Network latency is high and may cause lag during the interview',
    networkOffline: 'The browser is currently offline',
    networkLimited: 'Online, but latency check could not be completed',
    browserWaiting: 'Waiting for browser check',
    browserReady: 'This browser supports camera and microphone checks',
    browserChromeRequired: 'Your Chrome version is outdated. Upgrade to version {version} or later.',
    browserChromeLatest: 'This is not Chrome. Open the page in the latest version of Chrome.',
    browserUnsupported: 'This browser does not support camera or microphone checks',
    browserInsecure: 'Open this page over HTTPS or localhost before checking',
    permissionDenied: 'Allow camera and microphone access in the browser, then try again.',
    deviceNotFound: 'No available device was found. Check that it is connected.',
    deviceBusy: 'The device may be used by another app. Close it and try again.',
    deviceFailed: 'Failed to start the device. Check browser and system settings.',
  },
  table: {
    name: 'Name',
    number: 'Number',
    gender: 'Gender',
    status: 'Status',
    callStatus: 'Call Status',
    callStatusText: {
      undo: 'Not Called',
      calling: 'Called',
    },
    score: 'My Rating',
    average: 'Average',
    class: 'Class',
    checkIn: 'Checked in',
    signIn: 'Signin',
    preview: 'Preview',
    noMsg: 'No candidates yet',
    actions: 'Actions',
    aboveAverage: 'Above average',
    belowAverage: 'Below average',
    statusText: {
      unsubmitted: 'In progress',
      waiting: 'Not started',
      interviewing: 'In progress',
      complete: 'Completed',
      processing: 'Finished',
      confirmed: 'Finished',
      unconfirmed: 'Unconfirmed',
    },
    button: {
      unsubmitted: 'Adjust',
      waiting: 'Scoring',
      interviewing: 'Scoring',
      complete: 'Adjust',
      processing: 'View',
      confirmed: 'Adjust',
      unconfirmed: 'Adjust',
      view: 'View',
    },
    genderOption: {
      男: 'Male',
      女: 'Famale',
    },
    scoreTag: {
      unconfirmed: 'Rejected',
      confirmed: 'Approved',
      processing: 'Pending',
    },
  },
  video_interview: {
    tipMsg: 'Connect, please wait...',
    failMsg: 'Connection failed, please check camera and audio devices',
    retry: 'Click to try again',
    timeMsg: 'Video will end in minutes',
    videoMsg: 'Your video interview window is opened on another device or TAB',
    detectionMsg: 'Please try to open this page through a browser to access the camera device',
  },
  video_table: {
    scoreStatus: 'Class standard',
    arrangement: 'Schedule Name',
    time: 'Interview Time',
    name: 'Name',
    gender: 'Gender',
    score: 'Score',
    average: 'Average',
    class: 'Class',
    login: 'Logged in',
    online: 'online',
    offline: 'offline',
    view: 'View',
    noMsg: 'No candidates yet',
    status: {
      waiting: 'Not started',
      interviewing: 'In progress',
      complete: 'Complete',
      default: 'An error occurred',
    },
    genderOption: {
      男: 'Male',
      女: 'Famale',
    },
  },
  IframePopup: {
    title: "Candidate's test paper",
  },
  fontSize: {
    label: 'Font Size',
    size: {
      normal: 'Normal',
      large: 'Large',
      xlarge: 'Extra Large',
    },
  },
  FileViewer: {
    unknownFile: 'Unknown File',
    downloadFile: 'Download File',
    fileType: {
      doc: 'Word Document',
      xls: 'Excel Spreadsheet',
      ppt: 'PowerPoint Presentation',
      zip: 'Compressed File',
      audio: 'Audio File',
      video: 'Video File',
      fallback: '{ext} File',
    },
  },
};
